import { Component, OnInit, Input } from '@angular/core';

import { AppService } from '../../services/app.service';
import { MultiLangPipe } from '../../pipes/multi-lang.pipe';

interface HeadingCtrlInterface {
  languageCode: string;
  value: string;
}

interface LegendObject {
  key: string;
  path: string;
  source: string;
  pipe?: any;
}

@Component({
  selector: 'app-heading',
  templateUrl: './heading.component.html',
  styleUrls: ['./heading.component.scss']
})
export class HeadingComponent implements OnInit {

  @Input() public config: {
    text?: string | Array<HeadingCtrlInterface>;
    headingType: number;
    class: string;
    legend?: Array<LegendObject>,
    mapping?: {
      headingKey: string;
    }
  };
  @Input() public data: {customGetAPI?: Object | string, entityInformation?: Object | string };
  public legend = {};

  constructor(
    private appService: AppService
  ) { }

  /**
   * @author Sachin Jagtap
   * @task QLIKTAG-2983
   */
  ngOnInit() {

    if (this.config.hasOwnProperty('legend') && this.config.legend) {

      this.legend = this.appService.resolveLegend(this.config.legend, this.data);
    }

    if (this.config.hasOwnProperty('mapping') && this.config.mapping.hasOwnProperty('headingKey') && this.config.mapping['headingKey']) {
      const path = this.config.mapping.headingKey.split('.');
      const text = this.appService.findObjectByPath(this.data, path);

      if (typeof(text) === 'string' || Array.isArray(text)) {
        this.config.text = text;
      }
    }
  }

}
